import {DepositCurrency} from "protocol/response/GetDepositConfigurationsResponse";
import {EduTradingPackage} from "core/redux/deposit/DepositReduxState";
import {SetDepositAmount, SetDepositCurrency} from "core/redux/deposit/DepositReduxActions";
import Platform from "platform/Platform";
import {TSMap} from "typescript-map";
import {Currency} from "platform/enum/Currency";

export class DepositState {

    private static _instance: DepositState;
    private _currencies: TSMap<Currency, DepositCurrency>;
    private _initialCurrency: DepositCurrency;
    private _targetPackage: EduTradingPackage;

    private constructor() {
    }

    public static instance(): DepositState {
        return this._instance || (this._instance = new this());
    }

    public setCurrencies(currencies: TSMap<Currency, DepositCurrency>, initialCurrency: DepositCurrency) {
        this._currencies = currencies;
        this._initialCurrency = initialCurrency;
        this.preselect();
    }

    public set targetPackage(value: EduTradingPackage) {
        this._targetPackage = value;
    }

    private preselect() {
        if (this._currencies && this._targetPackage) {
            const packageAssetName: Currency = this._targetPackage.purchase?.PriceAssetName;
            const packageCurrency: DepositCurrency = this._currencies?.get(packageAssetName);
            Platform.dispatch(SetDepositCurrency({
                currency: packageCurrency.Name
            }));
            Platform.dispatch(SetDepositAmount({value: this._targetPackage.purchase?.DiscountedPrice}));
        } else {
            Platform.dispatch(SetDepositCurrency({
                currency: this._initialCurrency?.Name
            }));
        }
    }
}
